import { Box, Typography } from "@mui/material";
import { useContext } from "react";
import CustomButton from "../../../../UIElements/CustomButton";
import { SignUpContext } from "../../../../../contexts";
import "../../../../components-styles.scss";
import EstablishmentContactFormWrapper from "../../../../Common/EstablishmentContactFormWrapper";

type EstablishmentContactFormProps = {
    goto: () => void;
    profilId: string;
    title: string;
    subTitle: string;
    jobTitle: string;
    nextStep: number;
};

export default function EstablishmentContactForm({
    goto,
    profilId,
    title,
    subTitle,
    jobTitle,
    nextStep,
}: EstablishmentContactFormProps) {
    const { updateSignupForm, ...signupForm } = useContext(SignUpContext);

    const { signupUser } = signupForm;
    const { contacts } = signupUser.establishment;

    const onSubmit = (data: any) => {
        updateSignupForm({
            ...signupForm,
            step: nextStep,
            signupUser: {
                ...signupForm.signupUser,
                establishment: {
                    ...signupForm.signupUser.establishment,
                    contacts: data.contacts,
                },
            },
        });
        goto();
    };

    return (
        <Box className="signup-form-root">
            <Box className="signup-form-title-container">
                <Typography className="signup-form-title">{title}</Typography>
                <Typography className="signup-form-sub-title ">
                    {subTitle}
                </Typography>
            </Box>
            <EstablishmentContactFormWrapper
                contacts={contacts}
                profilId={profilId}
                // jobTitle={jobTitle}
                onSubmit={onSubmit}
                formActionComponents={{
                    submit: (
                        <CustomButton
                            type="submit"
                            label="Étape suivante"
                            customsx={{
                                marginLeft: "auto",
                                marginRight: "auto",
                                marginTop: "3.5rem",
                                marginBottom: "auto",
                            }}
                        />
                    ),
                }}
            />
        </Box>
    );
}
